import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from '@components/Tooltip/Tooltip'
import InfoIcon from '@components/Icon/Info'
import SearchSvg from '@components/Icon/SearchSvg'

const FilterGroup = ({
  inView,
  label,
  labelClass,
  tooltipContent,
  onSearch,
  children,
  displayFlex
}) => {
  return (
    <div className={`filter-group ${inView ? 'filter-group__in-view' : ''}`}>
      {label && (
        <label className={labelClass || ''}>
          {label}
          {!!tooltipContent && (
            <Tooltip tooltip={tooltipContent}>
              <div className='iconWrapper'>
                <InfoIcon />
              </div>
            </Tooltip>
          )}
        </label>
      )}
      <div
        className={
          onSearch
            ? 'filter-input__with-button'
            : `filter-input ${displayFlex ? 'filter-input__flex' : ''}`
        }
      >
        {children}
        {!!onSearch && <SearchButton onClick={onSearch} />}
      </div>
    </div>
  )
}

FilterGroup.propTypes = {
  inView: PropTypes.bool,
  label: PropTypes.string || PropTypes.object,
  labelClass: PropTypes.string,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onSearch: PropTypes.func,
  children: PropTypes.element || PropTypes.array,
  displayFlex: PropTypes.bool
}

export default FilterGroup

const SearchButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className='button--primary'>
      <SearchSvg />
    </button>
  )
}

SearchButton.propTypes = {
  onClick: PropTypes.func
}
